import { TPickupPointProvider } from 'models/orders'
import { getCdekTrackingUrl } from './getCdekTrackingUrl'

interface DeliveryTrackingInfo {
  tracking?: string
  tracking_url?: string
  ozon_posting_numbers?: string[]
}

export const getOzonTrackingUrls = (deliveryInfo?: DeliveryTrackingInfo): string[] => {
  const numbers = [
    ...(deliveryInfo?.ozon_posting_numbers ?? []),
    ...(deliveryInfo?.tracking?.split(',') ?? [])
  ].map((number) => number.trim()).filter(Boolean)

  return Array.from(new Set(numbers)).map((number) =>
    `https://tracking.ozon.ru/?track=${encodeURIComponent(number)}`
  )
}

export const openOzonTrackingTabs = (urls: string[]): void => {
  urls.forEach((url) => window.open(url, '_blank', 'noopener,noreferrer'))
}

export const getDeliveryTrackingUrl = (
  deliveryInfo?: DeliveryTrackingInfo,
  provider?: TPickupPointProvider
): string | undefined => {
  if (provider === 'YANDEX' && deliveryInfo?.tracking) {
    return `https://dostavka.yandex.ru/ndd/tracking?order_tracking_id=${encodeURIComponent(deliveryInfo.tracking)}`
  }
  if (deliveryInfo?.tracking_url) return deliveryInfo.tracking_url
  if (provider === 'OZON') return undefined
  if (!deliveryInfo?.tracking) return undefined

  return getCdekTrackingUrl(deliveryInfo.tracking)
}
